import "./css/normalize.css"; //CSS reset
import "./css/site.css";

import React from "react";
import { Route, Routes } from "react-router-dom";

import { ROUTES } from "../data/content";
import ScrollToTop from "./general/ScrollToTop";
import Header from "./layout/Header";
import Footer from "./layout/Footer";
import Home from "./home/Home";
import NotFound from "./general/NotFound";

//One-page site (as on Wix) - the menu scrolls to the sections on the home page
const App = () => {
  return (
    <React.Fragment>
      <a
        className={"skip-link"}
        href={"#main"}
      >
        Skip to main content
      </a>
      <ScrollToTop />
      <Header />
      <main
        id={"main"}
        className={"site-main"}
      >
        <Routes>
          <Route
            path={ROUTES.HOME}
            element={<Home />}
          />
          <Route
            path={"*"}
            element={<NotFound />}
          />
        </Routes>
      </main>
      <Footer />
    </React.Fragment>
  );
};

export default App;
